<div class="lb-header">
  <div class="lb-header__icon">
    <i class="fa-solid fa-ranking-star"></i>
  </div>
  <h3 class="lb-header__title">{{ titleKey | translate }}</h3>
</div>

@if (loading) {
  <div class="lb-loading">
    <i class="fa-solid fa-spinner fa-spin"></i>
  </div>
} @else if (entries.length === 0) {
  <div class="lb-empty">
    <i class="fa-solid fa-hourglass-half"></i>
    <span>{{ 'DASHBOARD.LEADERBOARD.EMPTY' | translate }}</span>
  </div>
} @else {
  <ul class="lb-list">
    @for (entry of entries; track entry.studentId; let i = $index) {
      <li class="lb-row" [class.lb-row--me]="entry.isCurrentUser"
          [style.animation-delay]="(i * 0.08) + 's'">
        <div class="lb-rank" [style.color]="getRankColor(entry.rank)">
          @if (entry.rank <= 3) {
            <i [class]="getRankIcon(entry.rank)"></i>
          } @else {
            <span class="lb-rank__num">{{ entry.rank }}</span>
          }
        </div>

        <div class="lb-avatar" [style.background]="getRankColor(entry.rank)">
          {{ getInitials(entry) }}
        </div>

        <div class="lb-info">
          <span class="lb-name">{{ entry.firstName }} {{ entry.lastName }}</span>
          @if (entry.learningPathTitle) {
            <span class="lb-path">{{ entry.learningPathTitle }}</span>
          }
        </div>

        <div class="lb-xp">
          <span class="lb-xp__value">{{ entry.totalXp | number }}</span>
          <span class="lb-xp__label">XP</span>
        </div>
      </li>
    }
  </ul>
}
